import React, {ReactNode, useState} from 'react';
import * as Sentry from '@sentry/react';
import {ErrorPage} from '../../pages/ErrorPage';

interface ErrorBoundaryProps {
  children: ReactNode;
  inline?: boolean;
}

const ErrorBoundary = ({children, inline}: ErrorBoundaryProps) => {
  const [showDialog, setShowDialog] = useState(false);
  return (
    <Sentry.ErrorBoundary
      showDialog={showDialog}
      fallback={({error, eventId}) => {
        return (
          <ErrorPage
            inline={inline}
            onShowDialog={() => setShowDialog(true)}
            error={error as any}
            eventId={eventId}
            code="500"
            text="An error occurred."
            refresh
          />
        );
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundary;
